import "@babel/polyfill";
import "./services/i18next";

import React from "react";
import { createRoot } from "react-dom/client";
import r2wc from "@r2wc/react-to-web-component";
import WidgetsDeciderWrapper from "./WidgetsDeciderWrapper";
import * as serviceWorker from "./serviceWorker";

if (document.getElementById("prospect-marketplace")) {
	const container = document.getElementById("root");
	const root = createRoot(container);
	root.render(
		<WidgetsDeciderWrapper />,
		document.getElementById("prospect-marketplace")
	);
}

(function () {
	if (typeof window.CustomEvent === "function") return false;

	function CustomEvent(event, params) {
		params = params || { bubbles: false, cancelable: false, details: undefined };
		var evt = document.createEvent("CustomEvent");
		evt.initCustomEvent(event, params.bubbles, params.cancelable, params.details);
		return evt;
	}

	CustomEvent.prototype = window.Event.prototype;

	window.CustomEvent = CustomEvent;
})();


// window.addEventListener("bootstrap-done",()=>{
const ProspectMarketplace = r2wc(WidgetsDeciderWrapper, {
	props: {
		flow: "string",
		clientId: "string",
		type: "string",
		companyName: "string",
		ecpdId: "string",
		mbaUserId: "string",
		mbaUserEmail: "string",
		mbtSessionId: "string",
		mbaRole: "string",
		clientName: "string",
	},
});
customElements.define("prospect-marketplace", ProspectMarketplace);

serviceWorker.unregister();
